import { __assign } from '../../../_virtual/_tslib.js';
import * as React from 'react';
import { IconWrapper } from '../../../components/icon-wrapper.js';

var SvgFeatherFilterX = React.forwardRef(function SvgFeatherFilterX(props, ref) {
    return (React.createElement(IconWrapper, __assign({ ref: ref }, props), React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055" }),
        React.createElement("path", { d: "m22 3-5 5" }),
        React.createElement("path", { d: "m17 3 5 5" }))));
});

export { SvgFeatherFilterX as default };
